/**
 * Queries en mutaties die zelf met "geen netwerk" omgaan (testrapport 28 okt. 2026, #3, #4, #15).
 *
 * TanStack Query pauzeert standaard (`networkMode: 'online'`) elke query en mutatie zodra de browser
 * `offline` meldt: de functie loopt dan gewoon niet. Voor een gewoon scherm is dat goed, maar de
 * offline-app is net gebouwd op het omgekeerde: altijd het verzoek doen en bij een netwerkfout
 * terugvallen op de kopie of de wachtrij (`use-offline.tsx`, ADR-0046/0047). Gepauzeerd kwam een
 * offline afgevinkt checklist-item nooit in de wachtrij, en bleven de ploegoverdracht en een nooit
 * geopend bericht eindeloos laden.
 *
 * Dus: alleen waar de functie zelf een terugval heeft (kopie, wachtrij of IndexedDB), laat de query of
 * mutatie altijd lopen. Gewone mutaties blijven gepauzeerd en gaan vanzelf zodra er weer netwerk is.
 */
export const HANDLES_OFFLINE = { networkMode: 'always' } as const;

/**
 * Er is geen antwoord van de server én geen kopie op het toestel.
 *
 * Een eigen fout, zodat het scherm dat anders kan zeggen dan "dit bericht is er niet": het bericht
 * bestaat misschien wel, alleen werd het nooit geopend toen er netwerk was.
 */
export class NotOnDeviceError extends Error {
  constructor() {
    super('Niet op dit toestel en geen verbinding');
    this.name = 'NotOnDeviceError';
  }
}

export function isNotOnDevice(error: unknown): boolean {
  return error instanceof NotOnDeviceError;
}
